import { Component,OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { CustomValidators } from 'ng2-validation';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router} from '@angular/router';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
const breadcrumb: any[] = [
  {
    title: 'Home'
   
  },
  {
    title: 'Customer'
  
  },
  {
    title: 'Add customer'
   
  }
];

//const password = new FormControl('', Validators.required);
//const confirmPassword = new FormControl('', CustomValidators.equalTo(password));

@Component({
  selector: 'page-customer-form-add',
  templateUrl: './customer-form-add.html',
  styleUrls: ['./customer-form-add.scss']
})


export class PageCustomerAdd implements OnInit {

  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  public form: FormGroup;
  data: any;
  rows=[];
  arrContact=[];
  
  //diaglog
  dialogRef: MdDialogRef<CustomerAddDialog>;
  selectedOption: string;
  gIndex:any=null;gIndexCk:boolean=false;
  ckNullContact:boolean=false;

  constructor(private httpservice:httpservice,public dialog: MdDialog,private fb: FormBuilder, private _sharedService: SharedService,private router: Router) {

    this._sharedService.emitChange(this.pageTitle);
  }

    openDialog() {
    let dialogRef = this.dialog.open(CustomerAddDialog);
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      
      if(result==='1'){
        this.postString();
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }

    });
  }

  openDialogDelete(id:String) {
    let dialogRef = this.dialog.open(CustomerAddDialog);
     dialogRef.afterClosed().subscribe(result => {
      if(result==='1'){
        this.delete(id);
      }else{
      }
    });
  }

  add(){
   
    if(this.form.controls.contactname.value==undefined){
      this.ckNullContact = true;
    }else{
    let value = {
      tb21f_name:this.form.controls.contactname.value,
      tb21f_phone:this.form.controls.phone.value,
      tb21f_email:this.form.controls.email.value,
      tb21f_department:this.form.controls.department.value
    }
    this.rows.push(value);
    this.rows = [...this.rows];
    this.form.controls.contactname.reset();
    this.form.controls.phone.reset();
    this.form.controls.email.reset();
    this.form.controls.department.reset();
    this.ckNullContact = false;
  }
  }

  delete(index:any){
    this.rows.splice(index,1);
    this.rows = [...this.rows];

  }

  setEdit(index:any){
    this.gIndex = index;
    this.gIndexCk = true;
    this.form.controls.contactname.setValue(this.rows[index].tb21f_name);
    this.form.controls.phone.setValue(this.rows[index].tb21f_email);
    this.form.controls.email.setValue(this.rows[index].tb21f_email);
    this.form.controls.department.setValue(this.rows[index].tb21f_department);

  }

  edit(){
    let value = {
      tb21f_name:this.form.controls.contactname.value,
      tb21f_phone:this.form.controls.phone.value,
      tb21f_email:this.form.controls.email.value,
      tb21f_department:this.form.controls.department.value
    }
    this.rows[this.gIndex] = value;
    this.rows = [...this.rows];
    this.gIndex = null;
    this.gIndexCk = false;
    this.form.controls.contactname.reset();
    this.form.controls.phone.reset();
    this.form.controls.email.reset();
    this.form.controls.department.reset();
    this.ckNullContact = false;
  }


  postString() {
    let dialogRef = this.dialog.open(customerLoadingAddDialog, { disableClose: true });
    let instance = dialogRef.componentInstance;
    instance.Message = "wait.....";
    let value = {
      branch:this.form.controls.branch.value,
      taxid:this.form.controls.taxid.value,
      address:this.form.controls.address.value,
      shortname:this.form.controls.shortname.value.replace(/&/g, '^'),
      fullname:this.form.controls.fullname.value.replace(/&/g, '^'),
      website:this.form.controls.website.value,
      arrContact:this.rows
    };
    
    this.httpservice.fetchpost('insertDataCustomer.php',value,cb=>{
      this.dialog.closeAll();
      this.router.navigateByUrl('default-layout/customer');

    });

  }
  ngOnInit() {

    this.form = this.fb.group({
      //stateCtrl: [null, Validators.compose([Validators.required])],
      shortname: [null, Validators.compose([Validators.required])],
      fullname: [null, Validators.compose([Validators.required])],
      contactname: [null, Validators.compose([Validators.required])],
      phone: [null, Validators.compose([Validators.required])],
      email: [null, Validators.compose([Validators.required])],
      website: [null, Validators.compose([Validators.required])],
      address: [null, Validators.compose([Validators.required])],
      taxid: [null, Validators.compose([Validators.required])],
      branch: [null, Validators.compose([Validators.required])],
      department:[null, Validators.compose([Validators.required])]
    });



  }
}

//dialog
@Component({
  selector: 'loading-dialog',
  templateUrl: 'loading-dialog.html',
})
export class customerLoadingAddDialog {
  Message = '';
  Title = '';
  constructor(public dialogRef: MdDialogRef<customerLoadingAddDialog>) { }
}

//dialog
@Component({
  selector: 'customer-dialog',
  templateUrl: 'customer-dialog.html',
})
export class CustomerAddDialog {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<CustomerAddDialog>) {}
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/customer/customer-form-add.ts